// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__1KN9i","title":"card_title__3pEY2","inActive":"card_inActive__2GEqP"};